import React, { Suspense } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Footer } from "./Footer";
import Header from "./Header";
import LoadingPage from "../components/Common/LoadingPage";
import ContactCallActionContainer from "../components/Common/ContactAction/ContactCallActionContainer";

export const Layout = () => {
  const location = useLocation();
  return (
    <>
      <Header />
      <Suspense fallback={<LoadingPage />}>
        <main className="App">
          <Outlet />
        </main>
      </Suspense>
      {location.pathname !== "/contact" && <ContactCallActionContainer />}
      <Footer />
    </>
  );
};
